export default "__VITE_ASSET__tL14siSj__"